var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Password_icon_1",
    "data-name": "Password icon 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.663,
    height: 13.598,
    viewBox: "0 0 22.663 13.598",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M2761.332,400c-4.586,0-8.669,2.658-11.332,6.8,2.663,4.141,6.746,6.8,11.332,6.8s8.669-2.658,11.332-6.8C2770,402.658,2765.917,400,2761.332,400Zm0,11.332a4.533,4.533,0,1,1,4.533-4.533A4.533,4.533,0,0,1,2761.332,411.332Z",
    transform: "translate(-2750 -400)",
    fill: "#0F1643"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 2.694,
    cy: 2.694,
    r: 2.694,
    transform: "translate(8.62 4.095)",
    fill: "#0F1643"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.8297c3d328ba3110ebde4eb6f9a2e443.svg";
export { ForwardRef as ReactComponent };